import { __assign, __makeTemplateObject, __rest } from "tslib";
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toPascalCase } from '@savantly/sprout-api';
import { css, cx } from 'emotion';
import React from 'react';
import { monoIcons } from '../../types/icon';
import * as MonoIcon from './assets';
library.add(fab, fas, far);
// a bit fragile, as we're using an internal property to get the list
//@ts-ignore
export var fasIcons = Object.keys(library.definitions.fas);
//@ts-ignore
export var fabIcons = Object.keys(library.definitions.fab);
//@ts-ignore
export var farIcons = Object.keys(library.definitions.far);
var getIconStyles = function () {
    return {
        container: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      label: Icon;\n      display: inline-block;\n    "], ["\n      label: Icon;\n      display: inline-block;\n    "]))),
        icon: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      vertical-align: middle;\n      display: inline-block;\n      margin-bottom: 0.2rem;\n      fill: currentColor;\n    "], ["\n      vertical-align: middle;\n      display: inline-block;\n      margin-bottom: 0.2rem;\n      fill: currentColor;\n    "]))),
        orange: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      fill: orange;\n    "], ["\n      fill: orange;\n    "])))
    };
};
export var Icon = React.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'sm' : _c, _d = _a.type, type = _d === void 0 ? 'default' : _d, name = _a.name, className = _a.className, style = _a.style, wrapperProps = _a.wrapperProps, faProps = __rest(_a, ["size", "type", "name", "className", "style", "wrapperProps"]);
    var styles = getIconStyles();
    var svgSize = getSvgSize(size);
    var _type = type;
    var _name = name;
    // Allow name to include type
    var nameParts = name.split(' ');
    if (nameParts.length > 1) {
        _type = nameParts[0];
        _name = nameParts[1];
    }
    // If a specific type was passed, don't overwrite it
    if (type === 'default') {
        if (monoIcons.includes(_name)) {
            _type = 'mono';
        }
        else if (fasIcons.includes(_name)) {
            _type = 'fas';
        }
        else if (fabIcons.includes(_name)) {
            _type = 'fab';
        }
        else if (farIcons.includes(_name)) {
            _type = 'far';
        }
        else {
            _type = 'default';
        }
    }
    else {
        _type = type;
    }
    if (_type === 'default') {
        return React.createElement("i", __assign({ className: cx(_name, className) }, wrapperProps, { style: style }));
    }
    var iconName = _type === 'mono' ? toPascalCase(_name) : _name;
    if (_type == 'mono') {
        //@ts-ignore
        var Component = MonoIcon[iconName];
        return (React.createElement(Component, { size: svgSize, className: cx(styles.icon, (_b = {}, _b[styles.orange] = iconName === 'favorite', _b), className), style: style }));
    }
    else {
        var faSize = size !== 'md' ? size : 'lg';
        return (React.createElement("div", __assign({ className: styles.container }, wrapperProps, { ref: ref }),
            React.createElement(FontAwesomeIcon, __assign({ icon: { prefix: _type, iconName: iconName }, size: faSize, className: cx(styles.icon, className), style: style }, faProps))));
    }
});
Icon.displayName = 'Icon';
/* Transform string with px to number and add 2 pxs as path in svg is 2px smaller */
export var getSvgSize = function (size) {
    switch (size) {
        case 'xs':
            return 12;
        case 'sm':
            return 14;
        case 'md':
            return 16;
        case 'lg':
            return 18;
        case '1x':
            return 24;
        case '2x':
            return 36;
        case '3x':
            return 48;
        case '4x':
            return 56;
        case '5x':
            return 64;
        case '6x':
            return 72;
        case '7x':
            return 86;
        case '8x':
            return 96;
        case '9x':
            return 128;
        case '10x':
            return 180;
    }
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Icon.js.map